import { z } from 'zod';

type FullNameValidatorOptions = {
  messages?: Partial<{
    required: string;
    fullNameRequired: string;
    onlyLettersAndAccentsIsAllowed: string;
  }>;
};

const fullNameValidator = ({ messages }: FullNameValidatorOptions = {}) => {
  return (value: string, ctx: z.RefinementCtx) => {
    if (!value) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.required || 'O nome é obrigatório',
      });
      return;
    }

    const nameRegex = new RegExp(/^[a-zA-ZÀ-ÖØ-öø-ÿ ]+$/);

    if (value.split(' ')[0].length < 2) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.fullNameRequired || 'O nome é obrigatório',
      });
      return;
    }

    if (value.split(' ').length < 2 || !value.split(' ')[1]) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.fullNameRequired || 'O nome é obrigatório',
      });
      return;
    }

    if (!nameRegex.test(value)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.onlyLettersAndAccentsIsAllowed || 'Apenas letras e acentuações são permitidas',
      });
      return;
    }

    return value;
  };
};

export default fullNameValidator;
